module.exports = __webpack_public_path__ + "img/img_health.298c9460.png";